var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"py-10 px-5 btn-height",attrs:{"value":_vm.value,"active-class":"btnn-active "}},[_c('div',{class:['cir', _vm.color]})])
}
var staticRenderFns = []

export { render, staticRenderFns }